import { Component } from '@angular/core';

@Component({
  host: { class: 'block whitespace-nowrap' },
  selector: 'avs-breadcrumbs',
  standalone: true,
  template: '<ng-content />',
})
export class BreadcrumbsComponent { }
